import { PodcastCardProps } from "../../components/Cards/BlogCard/PodcastCard";
import { PodcastTypes } from "../../enums/tags";
import Post from "../../interfaces/post";
import formatDate from "./formatDate";
import TextureAI from "../../assets/podcast-textures/texture_background_AI_Live_Unbiased.svg";
import TextureAgile from "../../assets/podcast-textures/texture_background_AgileCoaches.svg";
import TextureAutomation from "../../assets/podcast-textures/texture_background_AutomationExplanation.svg";
import { getText } from "./cmsToBlog";

interface PodcastSettings {
    baseurl: string,
    background: string,
    texture: React.FunctionComponent<React.SVGAttributes<SVGElement>>,
}

export const Settings: Record<string, PodcastSettings> = {
  [PodcastTypes.AutomationExplanation]: {
    baseurl: 'automation-explanation',
    texture: TextureAI,
    background: "bg-at-insignths-podcast-one",
  },
  [PodcastTypes.AIPodcast]: {
    baseurl: 'ai-podcast',
    texture: TextureAutomation,
    background: "bg-at-insignths-podcast-two",
  },
  [PodcastTypes.Default]: {
    baseurl: 'podcast',
    texture: TextureAutomation,
    background: "bg-at-insignths-podcast-two",
  },
  [PodcastTypes.AgilePodcast]: {
    baseurl: 'agile-podcast',
    texture: TextureAgile,
    background: "bg-at-insignths-podcast-three",
  },
  [PodcastTypes.Agile]: {
    baseurl: 'agile-podcast',
    texture: TextureAgile,
    background: "bg-at-insignths-podcast-three",
  },
};

const cmsToPodcast = ( post: Post ) : PodcastCardProps => {
    const podcast = post.tags?.find(tag => Object.keys(Settings).includes(tag.tag))?.tag || 'Default'; 

    return {
        title: post.title,
        body: post.content.filter(c => c.type === 'p' || !c.type).slice(0,2).map(getText).join('') || '',
        duration: `${post.duration || '5'} min listen`,
        date: formatDate(post.postDate || ''),
        type: 'Podcast',
        image: post.image?.url,
        tag: post.tags?.[0]?.tag || '',
        className: Settings[podcast].background,
        Texture: Settings[podcast].texture,
        linkTo: `/${Settings[podcast].baseurl}/${post.slug}/`,
    }
};

export default cmsToPodcast;
